
import React, { forwardRef, useRef, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes, parseSelectOptions } from 'utils/formUtils';
import { isEmpty } from 'lodash';
import GenericMappingForm from '../GenericMappingForm';
import { SEMGREP_CATEGORY_SECRETS } from '../new/util';

const SemgrepMappingForm = forwardRef(function SemgrepMappingForm({ disableProjectFields = false, ...props}, ref) {
  const semgrepCategories = SEMGREP_CATEGORY_SECRETS;

  const [initialValues] = useState(() => {
    if (props.record) {
      return undefined;
    }
    return [
      {
        product: props.defaultProduct,
        subProduct: props.defaultSubProduct,
        subProductId: props.defaultSubProductId,
        environment: props.defaultEnvironment,
        scanType: semgrepCategories.map((type) => type),
      },
    ];
  });

  const projectOptionsRef = useRef({});

  const api = useCallback((params) => ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId, ...params }), [props.loginConfigId, props.toolName])

  const getExtraFieldsData = useCallback((config) => {
    const { projectId, scanType } = config;
    return {
      projectId,
      scanType: isEmpty(scanType) ? [] : scanType.join(),
      projectName: projectOptionsRef.current[projectId],
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id }),
    };
  }, [])

  const parseExtraFieldsDataFromResponse = (config) => {
    const { projectId, scanType } = config;
    return {
      scanType: isEmpty(scanType) ? undefined : scanType.split(','),
      projectId,
      //send the property received in config
      ...(config.discovery_config_id && {
        discovery_config_id: config.discovery_config_id,
      }),
    };
  };

  const extraFields = useMemo(() => ([{
    name: 'projectId',
    colSpan: '12',
    type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
    label: 'Project Name',
    required: true,
    disabled: disableProjectFields,
    props: {
      autoFocus: !disableProjectFields,
      api: api,
      parseSelectOptions: (options) => {
        options.forEach(({ id, name }) => { projectOptionsRef.current[id] = name; });
        if(props.record){
          const { projectId, projectName } = props.record;
          projectOptionsRef.current[projectId] = projectName;
          return parseSelectOptions([...options, { id: projectId, name: projectName }])
        }
        return parseSelectOptions(options)
      }
    }
  },
  {
      label: 'Scan Type',
      name: 'scanType',
      colSpan: 11,
      type: FieldTypes.MULTI_SELECT,
      options: semgrepCategories,
      placeholder: "Leave empty to fetch across scan types"
  },
  ]), [disableProjectFields, api, props.record, semgrepCategories]);

  return (
    <GenericMappingForm
      ref={ref}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      formDefaultValues={initialValues}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default SemgrepMappingForm;